import { accelApi as api } from './http'

export { clearSession, sessionRole, setSession } from '../utils/session'

export const getGateInfo = () => api.get('/gate').then((res) => res.data)
export const loginVisitor = (password) => api.post('/login', { password }).then((res) => res.data)
export const loginAdmin = (password) => api.post('/admin/login', { password }).then((res) => res.data)
export const listCards = (params) => api.get('/cards', { params }).then((res) => res.data)

export const adminListCards = (params) => api.get('/admin/cards', { params }).then((res) => res.data)
export const adminVendorTree = (params) => api.get('/admin/vendors/tree', { params }).then((res) => res.data)
export const adminCreateVendor = (payload) => api.post('/admin/vendors', payload).then((res) => res.data)
export const adminUpdateVendor = (id, payload) => api.put(`/admin/vendors/${id}`, payload).then((res) => res.data)
export const adminDeleteVendor = (id) => api.delete(`/admin/vendors/${id}`).then((res) => res.data)
export const adminCreateCard = (payload) => api.post('/admin/cards', payload).then((res) => res.data)
export const adminGetCard = (id) => api.get(`/admin/cards/${id}`).then((res) => res.data)
export const adminUpdateCard = (id, payload) => api.put(`/admin/cards/${id}`, payload).then((res) => res.data)
export const adminDeleteCard = (id) => api.delete(`/admin/cards/${id}`).then((res) => res.data)
export const adminAddAttr = (id, payload) => api.post(`/admin/cards/${id}/attrs`, payload).then((res) => res.data)
export const adminUpdateAttr = (id, payload) => api.put(`/admin/attrs/${id}`, payload).then((res) => res.data)
export const adminDeleteAttr = (id) => api.delete(`/admin/attrs/${id}`).then((res) => res.data)
export const adminAddPrice = (id, payload) => api.post(`/admin/cards/${id}/prices`, payload).then((res) => res.data)
export const adminUpdatePrice = (id, payload) => api.put(`/admin/prices/${id}`, payload).then((res) => res.data)
export const adminDeletePrice = (id) => api.delete(`/admin/prices/${id}`).then((res) => res.data)
export const adminListPasswords = () => api.get('/admin/passwords').then((res) => res.data)
export const adminIssueLoginCode = () => api.post('/admin/login-codes').then((res) => res.data)
export const adminAddPassword = (payload) => api.post('/admin/passwords', payload).then((res) => res.data)
export const adminUpdatePassword = (id, payload) => api.put(`/admin/passwords/${id}`, payload).then((res) => res.data)
export const adminDeletePassword = (id) => api.delete(`/admin/passwords/${id}`).then((res) => res.data)
export const adminGetSettings = () => api.get('/admin/settings').then((res) => res.data)
export const adminPutSettings = (payload) => api.put('/admin/settings', payload).then((res) => res.data)

export default api
